<template>
  <SogFlexColumn>
    <div v-show="props.person.personType==='Natural'">
      <SogIcon icon="mdi-account" />
    </div>
    <div v-show="props.person.personType==='Legal'">
      <SogIcon icon="mdi-office-building" />
    </div>
    <SogDataLabel :value="props.person.personName" />
    <span><SogDataLabel :value="props.address?.street" /> <SogDataLabel :value="props.address?.houseNumber" /><SogDataLabel :value="props.address?.houseNumberAddition" /></span>
    <span><SogDataLabel :value="props.address?.postalCode" /> <SogDataLabel :value="props.address?.city" /></span>
    <SogDataLabel :value="props.address?.countryName" />
  </SogFlexColumn>
</template>

<script setup lang="ts">
import Person from "@/shared/model/person";
import Address from "@/shared/model/Address";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import SogIcon from "@/shared/ui/SogIcon.vue";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";

interface Props {
  person?:Person
  address?:Address
}
const props = withDefaults(defineProps<Props>(), {
  person: undefined,
  address:undefined
  }
)

</script>

<style scoped>
td{
  padding-right:10px;
}
.sog-card{
  min-width: 100px;
  width: auto;
  padding-top: 12px;
}

/*.e-card-content{font-size:14px;line-height:1.5;padding:0 18px 12px 18px}
*/
.sog-card{
}
</style>
